module.exports = __webpack_public_path__ + "assets/img/sf_icon1@2x.d803ec6d.png";